import { css } from '@emotion/core';
export var menu = {
  name: "k008qs",
  styles: "display:flex;"
};
export var column = {
  name: "cgq59l",
  styles: "flex-direction:column;"
};
export var row = {
  name: "1mktei2",
  styles: "flex-direction:row;gap:24px;width:fit-content;align-items:center;"
};
export var listItemColumn = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var listItemRow = {
  name: "u4p24i",
  styles: "display:flex;flex-direction:row;align-items:center;"
};